import React, { useCallback, useMemo } from 'react'
import { useGetAppFeatureMap } from 'src/api/app-features'
import { isAppFeatureEnabled, isAppFeatureIntegrationEnabled } from 'src/helpers/appFeatureHelper'
import { normalizeAppFeatureState } from 'src/helpers/appFeatureState'
import { FeatureFlagsCtx } from './FeatureFlagsContext'

/** Overrides global feature flags with per-customer map (Vessel-style per client). */
export const CustomerFeatureFlagsProvider: React.FC<{ customerId: number; children: React.ReactNode }> = ({
  customerId,
  children,
}) => {
  const { data, isLoading } = useGetAppFeatureMap([customerId])
  const state = normalizeAppFeatureState(data)
  const { features: flags, integrations } = state

  const isEnabled = useCallback((key: string) => isAppFeatureEnabled(key, flags), [flags])
  const isIntegrationEnabled = useCallback(
    (integrationKey: string) => isAppFeatureIntegrationEnabled(integrationKey, integrations),
    [integrations],
  )

  const value = useMemo(
    () => ({
      flags,
      integrations,
      isLoading,
      isEnabled,
      isIntegrationEnabled,
    }),
    [flags, integrations, isLoading, isEnabled, isIntegrationEnabled],
  )

  return <FeatureFlagsCtx.Provider value={value}>{children}</FeatureFlagsCtx.Provider>
}
